import { useEffect } from "react";

export interface ToastProps {
  message: string;
  type: "success" | "error";
  visible: boolean;
  onClose: () => void;
}

const Toast = ({ message, type, visible, onClose }: ToastProps) => {
  useEffect(() => {
    if (!visible) return;

    const timer = window.setTimeout(() => {
      onClose();
    }, 2500);

    return () => window.clearTimeout(timer);
  }, [onClose, visible]);

  if (!visible) return null;

  const baseClasses =
    "fixed bottom-4 right-4 z-50 flex max-w-sm items-start gap-3 rounded-2xl border border-white/20 px-4 py-3 shadow-2xl backdrop-blur-sm";
  const typeClasses =
    type === "success"
      ? "bg-emerald-600/95 text-white"
      : "bg-rose-600/95 text-white";

  return (
    <div
      className={`${baseClasses} ${typeClasses} animate-[fadeIn_180ms_ease-out]`}
    >
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/20">
        {type === "success" ? (
          <svg
            viewBox="0 0 24 24"
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        ) : (
          <svg
            viewBox="0 0 24 24"
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        )}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold leading-5">{message}</p>
      </div>
    </div>
  );
};

export default Toast;
